import React from 'react';
import {
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import UserAssignedCourseTable from './UserAssignedCourseTable';
import CohortAssignedCourseTable from './CohortAssignedCourseTable';
import OrganizationAssignedCourseTable from '@/containers/Cads-AI/ManageLearning/Assigned/components/course/OrganizationAssignedCourseTable';
import { useLocation } from 'react-router-dom';
import { ORGANIZATION, USERS, COHORT, assignedCourseORLPTabs } from '@/shared/helpers/constants';

const AssignedCourseTabs = () => {
  const [activeTab, setActiveTab] = React.useState(USERS);
  const location = useLocation();

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  React.useEffect(() => {
    const activeTabParam = new URLSearchParams(location.search)?.get('activeTab');
    if (
      activeTabParam &&
      activeTabParam !== activeTab &&
      [USERS, ORGANIZATION].includes(activeTab)
    ) {
      toggle(activeTabParam);
    }
  }, [location.search]);

  return (
    <Col className="card-body">
      <div className="tabs tabs--bordered-bottom">
        <div className="tabs__wrap">
          <Nav tabs>
            {Object.keys(assignedCourseORLPTabs).map((key) => (
              <NavItem key={assignedCourseORLPTabs[key].id}>
                <NavLink
                  className={classnames({ active: activeTab === assignedCourseORLPTabs[key].id })}
                  onClick={() => toggle(assignedCourseORLPTabs[key].id)}
                >
                  {assignedCourseORLPTabs[key].label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={activeTab}>
              <Container>
                <Row>
                  <CardBody>
                    {activeTab === USERS && <UserAssignedCourseTable />}
                    {activeTab === COHORT && <CohortAssignedCourseTable />}
                    {activeTab === ORGANIZATION && <OrganizationAssignedCourseTable />}
                  </CardBody>
                </Row>
              </Container>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </Col>
  );
};

export default AssignedCourseTabs;
